import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { RequisitionsCommonEffects } from './common/common.effects';
import { RequisitionsConfigEffects } from './config/config.effects';
import { RequisitionsConfigNamespace, RequisitionsConfigReducer } from './config/config.store';
import { RequisitionsFlowsEffects } from './flows/flows.effects';
import { RequisitionsFlowsNamespace, RequisitionsFlowsReducer } from './flows/flows.store';
import { RequisitionsFormEffects } from './form/form.effects';
import { RequisitionsFormNamespace, RequisitionsFormReducer } from './form/form.store';

@NgModule({
  imports: [
    EffectsModule.forFeature([RequisitionsConfigEffects]),
    EffectsModule.forFeature([RequisitionsFormEffects]),
    EffectsModule.forFeature([RequisitionsFlowsEffects]),
    EffectsModule.forFeature([RequisitionsCommonEffects]),
    StoreModule.forFeature(RequisitionsConfigNamespace, RequisitionsConfigReducer),
    StoreModule.forFeature(RequisitionsFormNamespace, RequisitionsFormReducer),
    StoreModule.forFeature(RequisitionsFlowsNamespace, RequisitionsFlowsReducer),
  ],
})
export class RequisitionsSettingsDataModule {}
